import React from "react"
import { useTranslation } from "react-i18next"
import {
  withFormik,
  FormikProps,
  FormikErrors,
  Form,
  Field,
  FieldProps,
} from "formik"
import { styled } from "@mui/material"

import i18n from "config/i18n"
import InputRating from "components/ui/InputRating"
import Button from "components/ui/Submit"
import { NpsFormValues } from "types"

interface FormProps {
  initialValues: {
    rating: number
    payment_schedule_id: string
  }
  onSubmit: (values: NpsFormValues) => void
}

type Props = FormikProps<NpsFormValues> & FormProps

const NpsForm = ({ isSubmitting }: Props) => {
  const { t } = useTranslation()

  return (
    <Form>
      <Field name="rating" type="number">
        {({ field }: FieldProps) => (
          <InputRating
            {...field}
            disabled={isSubmitting}
            value={parseInt(field.value)}
          />
        )}
      </Field>
      <Submit type="submit" disabled={isSubmitting}>
        {t("features.nps.form.submit")}
      </Submit>
    </Form>
  )
}

const NpsFormWithFormik = withFormik<FormProps, NpsFormValues>({
  enableReinitialize: true,
  mapPropsToValues: ({ initialValues }) => initialValues,
  handleSubmit: (values, { props: { onSubmit } }) => onSubmit(values),
  validate: (values: NpsFormValues) => {
    const errors: FormikErrors<NpsFormValues> = {}

    if (!values.rating) {
      errors.rating = i18n.t("validation.field.required", {
        field: i18n.t("features.nps.rating"),
      })
    }

    if (!values.payment_schedule_id) {
      errors.rating = i18n.t("validation.field.required", {
        field: i18n.t("features.nps.payment_schedule_id"),
      })
    }

    return errors
  },
})(NpsForm)

export default NpsFormWithFormik

const Submit = styled(Button)`
  border-radius: 21px;
  display: block;
  font-weight: bold;
  margin: 164px auto 0 auto;
  text-align: center;
  width: 116px;
`
